Object.defineProperty(exports, "__esModule", { value: true });
var SortedBy = /** @class */ (function () {
    function SortedBy() {
    }
    /**
     * Returns a new sequence with all elements sorted ascending by the value specified
     * by the given `selector` function.
     *
     * @param {(value: T) => R} selector
     * @returns {Sequence<T>}
     */
    SortedBy.prototype.sortedBy = function (selector) {
        return this.sorted(function (it) { return it.compareBy(selector); });
    };
    return SortedBy;
}());
exports.SortedBy = SortedBy;
//# sourceMappingURL=sortedBy.js.map